export default "__VITE_ASSET__hVZVWkQw__"